import { BULLETIN_TYPE } from '@/types/enums';

export const BULLETIN_NUMBER_LENGTHS: Record<string, number> = {
  [BULLETIN_TYPE.DIOCESAN]: 4,
  [BULLETIN_TYPE.LPI]: 7,
  [BULLETIN_TYPE.OTHER]: 6,
};

export const BULLETIN_NUMBER_MASKS: Record<string, string> = {
  [BULLETIN_TYPE.LPI]: '**-****',
  [BULLETIN_TYPE.NONE]: '',
  [BULLETIN_TYPE.DIOCESAN]: '0000',
  [BULLETIN_TYPE.OTHER]: '000000',
};

export const BULLETIN_TYPE_OPTIONS = [
  { value: BULLETIN_TYPE.NONE, label: 'None' },
  { value: BULLETIN_TYPE.DIOCESAN, label: 'Diocesan' },
  { value: BULLETIN_TYPE.LPI, label: 'LPI' },
  { value: BULLETIN_TYPE.OTHER, label: 'Other' },
];

export const validateBulletinNumber = (type: BULLETIN_TYPE, value: string): string | null => {
  if (type === BULLETIN_TYPE.NONE) {
    return null;
  }

  const trimmed = value.trim();
  const expectedLength = BULLETIN_NUMBER_LENGTHS[type];

  if (!trimmed) {
    if (type === BULLETIN_TYPE.OTHER) {
      return null;
    }
    return 'Bulletin number is required';
  }

  if (trimmed.length !== expectedLength) {
    return `Bulletin number must be exactly ${expectedLength} characters`;
  }

  if (type === BULLETIN_TYPE.DIOCESAN || type === BULLETIN_TYPE.OTHER) {
    if (!/^\d+$/.test(trimmed)) {
      return 'Bulletin number must contain only digits';
    }
  }

  if (type === BULLETIN_TYPE.LPI) {
    if (!/^[A-Za-z0-9]{2}-[A-Za-z0-9]{4}$/.test(trimmed)) {
      return 'Bulletin number must follow the format AA-1234 (2 letters/digits, dash, 4 letters/digits)';
    }
  }

  return null;
};
